<script setup lang="ts">
interface SectionProps {
  padded?: boolean
}

withDefaults(defineProps<SectionProps>(), {
  padded: false,
})
</script>

<template>
  <section class="section" :class="{ padded }">
    <slot />
  </section>
</template>

<style scoped>
.section.padded {
  margin-block: calc(var(--spacing) * 12);

  @screen lg {
    margin-block: calc(var(--spacing) * 27.5);
  }

  @screen 4xl {
    margin-block: calc(var(--spacing) * 48);
  }
}

/* .section:not(.padded):last-of-type {
  margin-bottom: calc(var(--spacing) * 12);

  @screen lg {
    margin-bottom: calc(var(--spacing) * 27.5);
  }
} */
</style>
